import { useCallback } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

/**
 * Reverse-geocode a coordinate to its closest formatted address. Must be used
 * inside an `<APIProvider>` (e.g. as a child of `AtomMap`/`AtomMapProvider`).
 * Resolves to '' when the geocoding library is not yet loaded or no match is
 * found. The geocoding library is loaded on demand by `useMapsLibrary`.
 */
const useReverseGeocoder = () => {
  const geocodingLibrary = useMapsLibrary('geocoding');

  return useCallback(
    async (latLng: google.maps.LatLngLiteral): Promise<string> => {
      if (!geocodingLibrary) {
        return '';
      }

      const geocoder = new geocodingLibrary.Geocoder();

      try {
        const { results } = await geocoder.geocode({ location: latLng });
        return results?.[0]?.formatted_address ?? '';
      } catch {
        return '';
      }
    },
    [geocodingLibrary],
  );
};

export default useReverseGeocoder;
